/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { Dialog, CardContent, Card, Button } from "@mui/material";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { useUpdateImage } from "cms/rich-text/simplicity-composer-tiptap/image/use-update-image";
import { ImageInPageEditorV2 } from "cms/images/image-inpage-editor-v2/index";
import { useCurrentEditor } from "@tiptap/react";
import { useSimplicityImage } from "cms/images/hooks/use-simplicity-image";
import { isGuid } from "utils/empty-exists";

const ImageSettingsDialog = (props) => {
    
    const {
        visible,
        setVisible
    } = props;
    
    const { image, updateImage } = useUpdateImage();
    const [settings,setSettings] = useState(image.settings);
    const { editor } = useCurrentEditor();
    const { isValidImage } = useSimplicityImage();
    const image_guid = image?.guid;

    useEffect(() => {
        setSettings(image.settings);
    }, [image.settings]);
    
    const handleClose = () => {
        const guid = image?.guid;
        if (!isGuid(guid)) {
            setSettings(undefined);
            editor.commands.deleteSelection();
            editor.commands.setNode("paragraph", {});
        }
        setVisible(false);
    };
    const onChangeImageWithSettings = async (image, settings) => {
        if (isValidImage(image)) {
            // setImage(image)
            setSettings(settings);
            updateImage(image, settings);
        } else {
            throw Error("Image supplied in onChangeImage was not a valid image.");
        }
    };
    const onRemoveImage = () => {
        setSettings(undefined);
        editor.commands.deleteSelection();
        editor.commands.setNode("paragraph", {});
    };
    const imageEditContext = {
        handleClose
    };
    
    return (
        <Fragment>
            <Dialog
                open={visible}
                onClose={handleClose}
                fullWidth={true}
                maxWidth='lg'
                className="simplicity-document-selector-overlay"
            >
                <ImageEditContext.Provider value={imageEditContext}>
                    <Card elevation={0} className='simplicity-image-settings-window'>
                        <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>
                            <Fragment>
                                <div className='simplicity-image-selector-window-title'>
                                    Image Settings
                                </div>
                            </Fragment>
                            
                            <div
                                style={{ padding: "24px", }}
                                className='simplicity-image-composer-container'
                            >
                                <ImageInPageEditorV2
                                    image_guid={image_guid}
                                    settings={settings}
                                    onChangeImageWithSettings={onChangeImageWithSettings}
                                    onRemoveImage={onRemoveImage}
                                />
                            </div>
                      
                        </CardContent>
                    </Card>
                    
                    <div className="simplicity-image-selector-window-footer">
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </div>
                
                </ImageEditContext.Provider>
            </Dialog>
        </Fragment>
    );
};

export { ImageSettingsDialog };
